module.exports = __webpack_public_path__ + "static/media/NISM Score Upload Template.52c549ae.xlsx";